import React, { useEffect, useState } from "react";
import { OPDFetch, OPDPrint } from "./OPD.Service";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ReuseableButton from "../../components/Buttons/button";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./OPDCloumn";
import { printFunc } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { errorToast } from "../../components/toastmessage/toastmessage";

const OPDTable = () => {
  const [opdList, setOPDList] = useState([])
  const navigate = useNavigate();

  const fetchOPDList = async () => {
    try {
      let res = await OPDFetch();
      if (res?.status === 200) {
        setOPDList(res?.data?.result)
      }
    } catch (err) {
      console.log(err, "popoo")
    }
  }
  useEffect(() => {
    fetchOPDList()
  }, []);
  const handleOpdClick = () => { }
  const handlePagination = () => { }
  const handleGetRowId = (e) => {
    return e?.opdid
  }
  const handleRouteBasicInfo = () => {
    navigate("/patient-registration/basic-information", { state: { addPatient: true, rowData: {} } })
  }
  const handlePrintClick = async (params) => {
    try {
      let res = await OPDPrint(params?.opdid)
      if (res?.status === 200) {
        await printFunc(res?.data, "opd")
      }
    } catch (err) {
      errorToast(err?.response?.data?.error || err?.response?.data?.message)

    }
  }
  const handlePay = (row) => {
    navigate("/patient-recieve-fee", { state: { patientID: row?.patientID, referralId: row?.referralID, rowData: row } })
  }
  const handleReportsClick = (row) => {
    navigate("/home/reports", { state: { patientID: row?.patientID, referralId: row?.referralID, rowData: row } })
  }
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div className="viewButton" onClick={() => handlePrintClick(params.row)}>PRINT</div>
            <div
              className="deleteButton"
              onClick={() => handlePay(params.row)}>
              PAY
            </div>
            <div className="viewButton" onClick={() => handleReportsClick(params.row)}>Reports</div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className='d-flex justify-content-end'>
        <div className="mr-5">
          <ReuseableButton
            text={"Add Patient"}
            height={45}
            colorVarient="success"
            fullWidthFlag={true}
            endIcon={<PersonAddAltIcon />}
            handleChange={handleRouteBasicInfo}
          />
        </div>
      </div>
      <div className="datatable">
        <DataGrid
          checkboxSelection={false}
          className="datagrid"
          rows={opdList && opdList !== null ? opdList : []}
          columns={userColumns.concat(actionColumn)}
          rowsPerPageOptions={[10]}
          getRowId={handleGetRowId}
          loading={opdList?.length > 0 || opdList === null ? false : false}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          onPageChange={(newPageSize) => handlePagination(newPageSize)}
          initialState={opdList}
          pagination
          pageSize={10}
          disableColumnMenu={true}
        />
      </div>
    </>
  )
}

export default OPDTable;
